module.exports = __webpack_public_path__ + "media/images/badges/akt/milestone-2-Active-AKT-4ec6ed0529aac3f4f88110aa8a91719f.png";